export default "__VITE_ASSET__Dn_Dkqj___"